interface HeroProps {
  onRunHappyPath: () => void;
}

export function Hero({ onRunHappyPath }: HeroProps) {
  return (
    <header className="hero" id="hero">
      <div className="top-bar">
        <span className="brand">REST Failure Matrix</span>
        <span className="privacy-pill" role="note">
          🔒 100% en tu navegador · nada sale de tu dispositivo
        </span>
      </div>
      <h1>Haz visible lo que normalmente falla en silencio.</h1>
      <p className="lede">
        Importa un contrato OpenAPI 3.1 y genera una matriz editable de casos de fallo 4xx/5xx por
        operación, con ejemplos de prueba exportables. Usa el ejemplo incluido o carga datos propios: el
        modo local no los envía a ningún servidor.
      </p>
      <div className="action-row">
        <button type="button" className="button button-primary" onClick={onRunHappyPath}>
          Ejecutar escenario
        </button>
        <a className="button button-secondary" href="#workbench">
          Ver el workbench
        </a>
      </div>
    </header>
  );
}
